import { AchievementId } from '../meta/achievements/AchievementId.ts';

export const ACHIEVEMENT_ICONS: Readonly<Record<AchievementId, string>> = {
  [AchievementId.FirstBlood]: '🩸',
  [AchievementId.NightWatch]: '🌙',
  [AchievementId.Gravedigger]: '⚰️',
  [AchievementId.Ghostbuster]: '👻',
  [AchievementId.BoneCollector]: '💀',
  [AchievementId.BruteForce]: '🪓',
  [AchievementId.CountDown]: '🧛',
  [AchievementId.NoOneLeftBehind]: '🤝',
  [AchievementId.GuardianAngel]: '😇',
  [AchievementId.Dawn]: '🌅',
  [AchievementId.Regular]: '🕯️',
  [AchievementId.Untouchable]: '🛡️',
  [AchievementId.MeatGrinder]: '🌪️',
  [AchievementId.BigSpender]: '💰',
  [AchievementId.MaxedOut]: '🔧',
  [AchievementId.Arsenal]: '🔫',
  [AchievementId.Survivor]: '⏳',
  [AchievementId.Herbalist]: '❤️',
  [AchievementId.Slasher]: '🗡️',
  [AchievementId.Butcher]: '🪓',
  [AchievementId.Berserk]: '🔥',
  [AchievementId.Bladesmith]: '⚔️',
  [AchievementId.Necromancer]: '🕯️',
};
